import { useEffect, useRef } from "react";

interface EmulatorProps {
  file: File;
  core: string;
}

const LOADER_SRC = "/emulatorjs/data/loader.js";

export function Emulator({ file, core }: EmulatorProps) {
  // React 19 StrictMode double-invokes effects in dev. EmulatorJS has no clean
  // re-boot, so guard against booting the loader twice.
  const bootedRef = useRef(false);

  useEffect(() => {
    if (bootedRef.current) return;
    bootedRef.current = true;

    window.EJS_player = "#game";
    window.EJS_core = core;
    // Pass the File object directly (NOT a blob: URL). EmulatorJS reads it via
    // FileReader instead of fetch()ing it — Discord's iframe CSP blocks blob:
    // in connect-src, which made the ROM download fail with "Network Error".
    window.EJS_gameUrl = file;
    window.EJS_pathtodata = "/emulatorjs/data/";
    // MANDATORY: the Discord Activity iframe has no SharedArrayBuffer, so
    // threaded cores cannot run. Force single-threaded.
    window.EJS_threads = false;
    window.EJS_startOnLoaded = true;
    window.EJS_gameName = file.name;
    window.EJS_color = "#5865F2";

    const script = document.createElement("script");
    script.src = LOADER_SRC;
    document.body.appendChild(script);

    return () => {
      script.remove();
      // Full teardown of EmulatorJS isn't reliable; the parent remounts this
      // component via `key` to get a clean slate.
    };
  }, [file, core]);

  // One-shot probe so we can confirm the isolation/threading environment.
  useEffect(() => {
    console.log(
      "[probe] crossOriginIsolated",
      self.crossOriginIsolated,
      "SharedArrayBuffer",
      typeof SharedArrayBuffer
    );
  }, []);

  return <div id="game" className="w-full h-full" />;
}
